import {useEffect} from 'react'
import {
  fetchServerAppVersion,
  getVersionId,
  isNewAppVersionAvailable,
  notifyAppVersionAvailable,
  reloadWithVersion,
  shouldAutoReloadForInitialVersion,
} from './appVersion'

const VERSION_CHECK_INTERVAL_MS = 60000

const AppVersionWatcher = () => {
  useEffect(() => {
    if (process.env.NODE_ENV !== 'production') {
      return
    }

    let disposed = false
    let isInitialCheck = true

    const checkVersion = async () => {
      const canAutoReload = isInitialCheck
      try {
        const payload = await fetchServerAppVersion()
        const nextVersionId = getVersionId(payload)
        if (disposed || !isNewAppVersionAvailable(payload)) {
          return
        }

        if (canAutoReload && shouldAutoReloadForInitialVersion(nextVersionId)) {
          reloadWithVersion(nextVersionId, true)
          return
        }

        notifyAppVersionAvailable(payload)
      } catch {
        // Version checks must never interrupt the current screen.
      } finally {
        isInitialCheck = false
      }
    }

    const checkVersionWhenVisible = () => {
      if (document.visibilityState === 'visible') {
        checkVersion()
      }
    }

    checkVersion()
    const intervalId = window.setInterval(checkVersion, VERSION_CHECK_INTERVAL_MS)
    window.addEventListener('focus', checkVersion)
    document.addEventListener('visibilitychange', checkVersionWhenVisible)

    return () => {
      disposed = true
      window.clearInterval(intervalId)
      window.removeEventListener('focus', checkVersion)
      document.removeEventListener('visibilitychange', checkVersionWhenVisible)
    }
  }, [])

  return null
}

export {AppVersionWatcher}
